/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from "react";

import SelectField from "../form/SelectField";
import DateField from "../form/DateField";
import TextFieldTimeField from "../form/TextFieldTimeField";
import SelectLocationField from "../form/SelectLocationField";
import SearchCache from "../utilities/cache";

export default ({ onSubmit, onChange, ...props }) => {
  const { params, RegionService, goDisabled } = props;

  let timeField = (
    <TextFieldTimeField name="time" onChange={e => onChange(e)} />
  );

  if (params.timeType === "first" || params.timeType === "last") {
    timeField = null;
  }

  const FormSearchCache = new SearchCache(RegionService);

  return (
    <form
      className="trip-definition-form journey-plan-new"
      autoComplete="off"
      autoCapitalize="off"
      autoCorrect="off"
      spellCheck="false"
      onSubmit={e => onSubmit(e)}
    >
      <div className="trip-definition-form-edit">
        <div className="to-from">
          <div className="to-from-labels">
            <div className="wide-field">
              <label htmlFor="from">From</label>
            </div>
            <div className="wide-field">
              <label htmlFor="to">To</label>
            </div>
          </div>
          <div className="reverse-container">
            <span
              className="pseudo-button reverse-direction-button"
              data-toggle="tooltip"
              title="Switch the 'from' and 'to' addresses"
            />
          </div>
          <div className="to-from-fields">
            <div className="wide-field">
              <SelectLocationField
                placeholder="Type in address, location or bus stop no"
                parameter="from"
                name="from"
                RegionService={RegionService}
                SearchCache={FormSearchCache}
                onChange={e => onChange(e)}
              />
            </div>
            <div className="wide-field">
              <SelectLocationField
                placeholder="Type in address, location or bus stop no"
                parameter="to"
                name="to"
                RegionService={RegionService}
                SearchCache={FormSearchCache}
                onChange={e => onChange(e)}
              />
            </div>
          </div>
        </div>

        {/* {{!-- for all forms --}} */}
        <div className="form-buttons">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={goDisabled}
          >
            Go
          </button>

          {/* {{!-- for the embedded form only --}} */}
          <div className="show-map-link">
            <a
              href={`${window.JPURL}?region=${window.REGION}#/journey_plans/create`}
            >
              + View map
            </a>
          </div>
        </div>

        {/* {{!-- for the desktop form only --}} */}
        <div className="time-preferences-embedded">
          <div className="field">
            <SelectField
              name="timeType"
              options={[
                { value: "dep", text: "Depart after", order: 1 },
                { value: "arr", text: "Arrive before", order: 2 },
                { value: "first", text: "First bus of the day", order: 3 },
                { value: "last", text: "Last bus of the day", order: 4 }
              ]}
              onChange={e => onChange(e)}
            />
            {timeField}
            <DateField name="date" onChange={e => onChange(e)} />
            <SelectField
              name="sortOrder"
              options={[
                { value: "duration", text: "Fastest trip" },
                { value: "transfers", text: "Least transfers" },
                { value: "walking", text: "Least walking" }
              ]}
              onChange={e => onChange(e)}
            />
          </div>
        </div>
        <div className="cleafix" />
      </div>

      <div className="trip-definition-form-view">
        <div className="field">
          <strong>From</strong>
        </div>
        <div className="field from-field">
          <strong>To</strong>
        </div>
      </div>
    </form>
  );
};
